import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import LabourSidebar from "../Layouts/LabourSidebar";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";

export class Partograph extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      rupturedmembranes: "",
      fetalHeartRate: "",
      liquor: "",
      moulding: "",
      descentofHead: "",
      cervicalDilatation: "",
      contractionper10min: "",
      oxytocin: "",
      drugsGiven: "",
      ivFluid: "",
      bloodPressure: "",
      pulse: "",
      temperature: "",
      urineProtein: "",
      urineAcetone: "",
      urineVolume: "",
      labournotes: "",
      myParentTrigger: "",
      patientName: localStorage.getItem("currentVisitName"),
      tablevaluesglobal: {},
      newtablevalues: {},
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".yesSelected").click(function () {
      $(".hiddenPart").show();
    });
    $(".noSelected").click(function () {
      $(".hiddenPart").hide();
    });
    console.log(this.state);
  }

  proceedEvent(event) {
    // window.location.href = '/theatre/post/op/observations/care2'
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange2(event) {}
  onTableChange(event) {}

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.rupturedmembranes = data[0][1];
      trimobj.fetalHeartRate = data[i][2];
      trimobj.liquor = data[i][3];
      trimobj.moulding = data[i][4];
      trimobj.descentofHead = data[i][5];
      trimobj.cervicalDilatation = data[i][6];
      trimobj.contractionper10min = data[i][7];
      trimobj.oxytocin = data[i][8];
      trimobj.drugsGiven = data[i][9];
      trimobj.ivFluid = data[i][10];
      trimobj.bloodPressure = data[i][11];
      trimobj.pulse = data[i][12];
      trimobj.temperature = data[i][13];
      trimobj.urineProtein = data[i][14];
      trimobj.urineAcetone = data[i][15];
      trimobj.urineVolume = data[i][16];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
  }
  formatTableOutput2(data) {
    // return data
    let topobj2 = {};
    let tableobj = {};

    // this.setState({
    //     newtablevalues :
    // })

    return topobj2["partograph"];
    // console.log(this.state.newtablevalues)
  }

  getTableValues(event) {
    // console.log('entns');
    // console.log(event);
    let tablevalues = this.formatTableOutput(event);
    // console.log(tablevalues);
  }
  getTableValues2(event) {
    var data = event[0];
    //    console.log(data)
    // var data = event.toStringsplit(",")
    // alert(data.length)
    let trimobj2 = {};

    trimobj2.bloodPressure = data[0];
    trimobj2.pulse = data[1];
    trimobj2.temperature = data[2];
    trimobj2.urineProtein = data[3];
    trimobj2.urineAcetone = data[4];
    trimobj2.urineVolume = data[5];

    this.setState({
      newtablevalues: trimobj2,
    });
    // console.log(event);
    //     let tablevalues = this.formatTableOutput2(event);
    //    alert(tablevalues);
  }
  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };

    // console.log(headers)

    event.preventDefault();
    // console.log(localStorage.getItem("objectLength"))
    var objectLength = localStorage.getItem("objectLength");

    // console.log(this.state.tablevaluesglobal[0]["rupturedmembranes"])

    var dict = {
      rupturedmembranes: this.state.tablevaluesglobal[0]["rupturedmembranes"],
      fetalHeartRate: this.state.tablevaluesglobal[0]["fetalHeartRate"],
      liquor: this.state.tablevaluesglobal[0]["liquor"],
      moulding: this.state.tablevaluesglobal[0]["moulding"],
      descentofHead: this.state.tablevaluesglobal[0]["descentofHead"],
      cervicalDilatation: this.state.tablevaluesglobal[0]["cervicalDilatation"],
      contractionper10min:
        this.state.tablevaluesglobal[0]["contractionper10min"],
      oxytocin: this.state.tablevaluesglobal[0]["oxytocin"],
      drugsGiven: this.state.tablevaluesglobal[0]["drugsGiven"],
      ivFluid: this.state.tablevaluesglobal[0]["ivFluid"],
      bloodPressure: this.state.newtablevalues["bloodPressure"],
      pulse: this.state.newtablevalues["pulse"],
      temperature: this.state.newtablevalues["temperature"],
      urineProtein: this.state.newtablevalues["urineProtein"],
      urineAcetone: this.state.newtablevalues["urineAcetone"],
      urineVolume: this.state.newtablevalues["urineVolume"],
      labournotes: this.state.labournotes,
    };

    // console.log(dict)
    this.setState({
      loading: true
    })

    axios
      .post(this.api_url+"labour/partograph", dict, {
        headers: headers,
      })
      .then((response) => {
        console.log(response);
        // /triage/antenatal/history
        if (response.data) {
          console.log(headers);
          axios
            .post(this.api_url+"labour/partograph", {
              headers: headers,
            })
            .then((response) => {
              console.log(response);
              this.setState({
                loading: false
              })
              let table = response.data;
              console.log(table);
              let object = {};
              for (let i = 0; i < table.length; i++) {
                delete table[i]._id;
                delete table[i].timeOfRegistration;
                table[i].clickEvent = () => this.handleRowClick(table[i]);
              }
              // table = JSON.stringify(table);
              this.TableData = table;
              console.log(this.TableData);
              this.setState({
                DataLoaded: true,
              });
            })
            .catch((error) => {
              console.log(error);
            });

          if (response.data["status"]) {
            $(".alert-success").show();
            // setTimeout(function () {

            //     // alert('sdsd')
            //     // window.location.href = '/send/to/module'
            // }, 1500);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }
  handleTableChange2(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  render() {
    //Editable table variables
    const data = [["", "", "", "", "", "", "", "", "", "", ""]];
    const data2 = [["", "", "", "", "", "", ""]];
    const columns = [
      "Date and Time",
      "Ruptured membranes",
      "Fetal Heart Rate ",
      "Liquor ",
      "Moulding ",
      "Descent of Head ",
      "Cervical Dilatation ",
      "Contraction per 10 min ",
      "Oxytocin U/L Drops/min ",
      "Drugs Given ",
      "IV Fluid ",
    ];
    const columns2 = [
      "Blood Pressure ",
      "Pulse ",
      "Temperature ",
      "Urine ",
      "Protein ",
      "Acetone ",
      "Volume",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };
    // {""":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const {
      AttendedAntenatalCare,
      NumPreviousVisits,
      FaciltyPreviousVisits,
      AntiTetanusVaccination,
      NumPreviousVaccinations,
      LastVaccinationDate,
      AnteNatalHistoryPreviousObstetricUltrasound,
      AnteNatalHistoryNumPreviousUltrasound,
      AnteNatalHistoryTableTrimester,
      AnteNatalHistoryTableDate,
      PreviousFacilityVisitDate,
      AnteNatalHistoryTableResult,
      patientName,
    } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "ObservationsCare1Time",
          field: "ObservationsCare1Time",
          sort: "asc",
          width: 50,
        },
        {
          label: "Airway",
          field: "Airway",
          sort: "asc",
          width: 50,
        },
        {
          label: "oxygen",
          field: "oxygen",
          sort: "asc",
          width: 50,
        },
        {
          label: "Resp",
          field: "Resp",
          sort: "asc",
          width: 50,
        },
        {
          label: "Pulse",
          field: "Pulse",
          sort: "asc",
          width: 50,
        },
        {
          label: "Temp",
          field: "Temp",
          sort: "asc",
          width: 50,
        },
        {
          label: "BP",
          field: "BP",
          sort: "asc",
          width: 50,
        },
        {
          label: "SPO2",
          field: "SPO2",
          sort: "asc",
          width: 50,
        },
        {
          label: "LOC",
          field: "LOC",
          sort: "asc",
          width: 50,
        },
        {
          label: "Headlift",
          field: "Headlift",
          sort: "asc",
          width: 50,
        },
        {
          label: "LimbObs",
          field: "LimbObs",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };

    const { labournotes, loading } = this.state;
    return (
      <div>
        <Headers />
        <LabourSidebar />
        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Maternal and Fetal Progress
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="#editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <br />
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Vital Sign and Urine Test
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange2(value)}
                    getValue={(value) => this.getTableValues2(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="#editablecard"
                    data={data2}
                    columns={columns2}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div className="py-1">
                <h6 className="text-capitalize" style={fontFamilyNunito}>
                  Labour Notes
                </h6>
                <textarea
                  onChange={this.handleChange}
                  value={labournotes}
                  name="labournotes"
                  className="form-control"
                  required
                ></textarea>
              </div>

              
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default Partograph;
